(() => {
	// ============================================
	// h2のテキストをサブテキストに変更
	// ============================================
	const addSubTxt = () => {
		const headings = document.querySelectorAll('h2.wp-block-heading');

		headings.forEach((h2) => {
			const html = h2.innerHTML;

			// <br>より前後を取得（最初の<br>のみ対象）
			const parts = html.split(/<br\s*\/?>/);

			// <br>が無かったらスキップ
			if (parts.length < 2) return;

			const before = parts[0];
			const after = parts.slice(1).join('');

			// 後ろにspanを追加、brは削除
			h2.innerHTML = `${before}<span class="txt-sub">${after}</span>`;
		});
	};
	// ============================================
	// iframeに親要素追加
	// ============================================
	const iframeWrap = () => {
		document.querySelectorAll('iframe').forEach((iframe) => {
			if (iframe.closest('.iframe-wrap')) return; // 既に.iframe-wrapがある場合はスキップ

			const wrapper = document.createElement('div'); //追加するHTML要素
			wrapper.className = 'iframe-wrap'; //追加するクラス名

			// wrapperをiframeの前に挿入
			iframe.parentNode.insertBefore(wrapper, iframe);
			wrapper.appendChild(iframe);
		});
	};
	// ============================================
	// ボタンにアイコン追加
	// ============================================
	const buttonIcon = () => {
		document.querySelectorAll('a.wp-element-button').forEach((a) => {
			if (a.querySelector('.arrow')) return; // 既に.arrowがある場合はスキップ

			const span = document.createElement('span');
			span.className = 'arrow';
			a.appendChild(span);
		});
	};

	// ============================================
	//実行
	// ============================================
	addSubTxt();
	iframeWrap();
	buttonIcon();
})();
